export default {
	status: {
		400: "リクエストが失敗しました。後でもう一度お試しください。",
		401: "ログインセッションが期限切れです。もう一度ログインしてください。",
		403: "現在のアカウントにはアクセス権限がありません。",
		404: "アクセスしようとしているリソースが存在しません。",
		405: "不正なリクエストメソッドです。後でもう一度お試しください。",
		408: "リクエストがタイムアウトしました。後でもう一度お試しください。",
		500: "サービスで例外が発生しました。",
		990: "長期間未完了のタスクがあるため、アカウントが凍結されました。",
		10030008: "現金引き出しを申請する前に、支援金を返却してください",
		10030010: "招待コードが存在しません",
		10030011: "チェックイン回数が最大回数を超えました",
		10030012: "チェックインの条件を満たしていません。まずタスクを完了してください",
		10030013: "サインインの設定エラーが発生しました。カスタマーサービスにお問い合わせください",
		10030014: "許可された時間帯内にありません",
		10030015: "メンバーが存在しません",
		10030016:
			"親愛なるユーザー様：おめでとうございます！製品プロモーションの100%を正常に完了しました。リセットをリクエストするには、プラットフォームのサポートにお問い合わせください。",
		10030017: "商品が一致しません。カスタマーサービスにお問い合わせください",
		10030018: "口座残高が不足しています",
		10030019: "アカウントは無効になっています",
		10030020: "アカウントの取引が禁止されています",
		10030021: "アカウントの引き出しが禁止されています",
		10030022: "取引パスワードエラー",
		10030023: "引き出し口座がバインドされていません。先に引き出し口座をバインドしてください",
		10030024: "古いパスワードエラー",
		10030027: "出金は制限されています。詳細についてはカスタマーサービスにお問い合わせください。",
		10030028: "低いクレジットスコアのため、お金を引き出すことができません",
		10030030: "許可された時間帯内にありません",
		10030031: "本日のタスクをリセットするには、カスタマーサービスにご連絡ください",
		10030050: "注文の有効期限が切れました。カスタマーサービスに連絡してください。"
	},
	errorHandler: {
		InternalError: "JavaScriptエンジンの内部エラー",
		ReferenceError: "オブジェクトが見つかりません",
		TypeError: "不正なタイプまたはオブジェクトの使用",
		RangeError: "組み込みオブジェクトを使用するときのパラメータが範囲外です",
		SyntaxError: "構文エラー",
		EvalError: "Evalの不正な使用",
		URIError: "URIエラー",
		UnknownError: "不明なエラー"
	},
	Network: {
		timedout: "リクエストがタイムアウトしました！後で再試行してください。",
		error: "ネットワークエラーが発生しました！後で再試行してください。"
	},
	request: {
		NoMoreData: "これ以上データはありません",
		OnlyImage: "画像ファイルのみアップロードしてください。",
		FileMaxSize: "ファイルサイズが最大値（{0}M）を超えています"
	},
	response: {
		loading: "ロード",
		success: "成功",
		fail: "失敗",
		complete: "完了"
	},
	page: {
		noVerify: "Portafoglio non verificato, si prega di verificare prima il portafoglio",
		notexist: "申し訳ありません、アクセスしようとしたページは存在しません~"
	}
};
